module.exports = __webpack_public_path__ + "static/media/corporateStep5.eaddce45.svg";